export default __webpack_public_path__ + "static/IMDA_SME_Large-f34815ebb0fee2c6e01cbf7a5fcede72.webp";